import Editor from '@monaco-editor/react'
import { useTheme } from '@/components/theme/ThemeProvider'
import { cn } from '@/lib/utils'

interface SystemPromptEditorProps {
  value: string
  onChange: (value: string) => void
  onBlur?: () => void
  useTextareaFallback?: boolean
  className?: string
  height?: string
}

export function SystemPromptEditor({
  value,
  onChange,
  onBlur,
  useTextareaFallback = false,
  className,
  height = '160px',
}: SystemPromptEditorProps) {
  const { resolvedTheme } = useTheme()
  const monacoTheme = resolvedTheme === 'dark' ? 'vs-dark' : 'vs'

  if (useTextareaFallback) {
    return (
      <textarea
        value={value}
        onChange={(event) => onChange(event.target.value)}
        onBlur={onBlur}
        className={cn(
          'min-h-24 w-full rounded-md border border-input bg-background px-3 py-2 text-sm',
          className,
        )}
        data-testid="chat-system-prompt-textarea"
        placeholder="System prompt..."
      />
    )
  }

  return (
    <div className={cn('overflow-hidden rounded-md border border-input', className)} data-testid="chat-system-prompt-monaco">
      <Editor
        height={height}
        language="markdown"
        theme={monacoTheme}
        value={value}
        onChange={(nextValue) => onChange(nextValue ?? '')}
        onMount={(editor) => {
          editor.onDidBlurEditorText(() => onBlur?.())
        }}
        options={{
          minimap: { enabled: false },
          wordWrap: 'on',
          fontSize: 13,
          scrollBeyondLastLine: false,
          automaticLayout: true,
        }}
      />
    </div>
  )
}
